var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPluginFileDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1261152138"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "delete",
    d: "M10.25 20.5C9.8375 20.5 9.48438 20.3531 9.19062 20.0594C8.89687 19.7656 8.75 19.4125 8.75 19V9.25H8V7.75H11.75V7H16.25V7.75H20V9.25H19.25V19C19.25 19.4125 19.1031 19.7656 18.8094 20.0594C18.5156 20.3531 18.1625 20.5 17.75 20.5H10.25ZM17.75 9.25H10.25V19H17.75V9.25ZM11.75 17.5H13.25V10.75H11.75V17.5ZM14.75 17.5H16.25V10.75H14.75V17.5Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#FFDF0A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluginFileDelete);
export default __webpack_public_path__ + "static/media/plugin_file_delete.d57275b2a3a8a98d0e756be97061a867.svg";
export { ForwardRef as ReactComponent };